/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** @format date-time */
  timestamp?: string;

  /** @format int32 */
  status?: number;
  error?: string;
  path?: string;
}

/**
 * Запрос при сохранении настроек пользователя
 */
export interface UserSettingsSaveRequest {
  /** Признак отображения клиенту онбординга по разделу "Площадки" */
  isOnboardingPromo?: boolean;

  /** Признак отображения клиенту онбординга по разделу "Онлайн-запись" */
  isOnboardingOnlineRecord?: boolean;

  /** Признак отображения клиенту онбординга по разделу "CRM" */
  isOnboardingCRM?: boolean;
}

/**
 * Настройки пользователя
 */
export interface UserSettingsResponse {
  /**
   * Идентификатор клиента
   * @format uuid
   */
  clientId?: string;

  /** Признак отображения клиенту онбординга по разделу "CRM" */
  isOnboardingCRM?: boolean;

  /** Признак отображения клиенту онбординга по разделу "МС Площадки" */
  isOnboardingPromo?: boolean;

  /** Признак отображения клиенту онбординга по разделу "МС Онлайн-запись" */
  isOnboardingOnlineRecord?: boolean;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис crm-ms-prd-profile
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://crm-ms-prd-profile.crmdbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OF_CRM <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=328012103)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Данные пользователя (профиль)
     * @name GetUserSettings
     * @summary Получение данных пользователя
     * @request GET:/api/crm-profile/external/v1/profile
     */
    getUserSettings: (params: RequestParams = {}) =>
      this.request<UserSettingsResponse, ErrorMessage>({
        path: `/api/crm-profile/external/v1/profile`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Данные пользователя (профиль)
     * @name SaveUserSettings
     * @summary Сохранение настроек пользователя
     * @request POST:/api/crm-profile/external/v1/profile
     */
    saveUserSettings: (
      data: UserSettingsSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorMessage>({
        path: `/api/crm-profile/external/v1/profile`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}

export const api = new Api();
